var map = {
	"./digital.png": "e148",
	"./ecommerce.png": "cd60",
	"./mobile app.png": "4f00",
	"./mobile-app.png": "00cd",
	"./software.png": "33dc",
	"./web app.png": "985b",
	"./web-app.png": "8304",
	"./website.png": "c79c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70ad";